import { useSyncExternalStore } from 'react';

export const PATH_METADATA_OMITTED_SNACKBAR_ID = 'path-metadata-omitted';

type Listener = () => void;

let pathMetadataOmittedWarning: string | null = null;
const listeners = new Set<Listener>();

const notifyListeners = () => {
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: Listener) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => pathMetadataOmittedWarning;

/** Sets (or clears with `null`) the deploy-time "path data omitted" warning message. */
export const setPathMetadataOmittedWarning = (message: string | null) => {
  if (pathMetadataOmittedWarning === message) {
    return;
  }

  pathMetadataOmittedWarning = message;
  notifyListeners();
};

export const usePathMetadataOmittedWarning = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
